const mainClickedText = document.querySelector(".bid_history");
const secClickedText = document.querySelector(".buyer_info_modal");
const bidhistoryModalModalNew = document.getElementById("bidhistoryModal");
const buyerpremimumModalModalNew = document.getElementById("buyer_premimum");
if (mainClickedText != null) {
  const bidhistoryModalClose = document.querySelector(".bidhistoryClose");
  const closebutton = document.querySelector(".closebtn");

  mainClickedText.addEventListener("click", async () => {
    bidhistoryModalModalNew.style.visibility = "visible";
    const auctionId = document.querySelector(".bid_history").dataset.auctionId;
    window.renderBidHistoryData(auctionId);
  });

  bidhistoryModalClose.addEventListener("click", () => {
    bidhistoryModalModalNew.style.visibility = "hidden";
  });
  closebutton.addEventListener("click", () => {
    bidhistoryModalModalNew.style.visibility = "hidden";
  });
}
if (secClickedText != null) {
  const buyer_premimumModalClose = document.querySelector(
    ".buyer_premimumClose"
  );
  const closebtn = document.querySelector(".closebutton");

  secClickedText.addEventListener("click", () => {
    buyerpremimumModalModalNew.style.visibility = "visible";
  });

  buyer_premimumModalClose.addEventListener("click", () => {
    buyerpremimumModalModalNew.style.visibility = "hidden";
  });
  closebtn.addEventListener("click", () => {
    buyerpremimumModalModalNew.style.visibility = "hidden";
  });
}

window.onclick = function (event) {
  if (event.target == buyerpremimumModalModalNew) {
    buyerpremimumModalModalNew.style.visibility = "hidden";
  } else if (event.target == bidhistoryModalModalNew) {
    bidhistoryModalModalNew.style.visibility = "hidden";
  }
};

window.renderBidHistoryData = async function (auctionId) {
  let historyTable = document.querySelector(".history_table");
    const loaderElement = document.createElement("div");
    loaderElement.style.textAlign = "center";
    var tableBody = document.querySelector(".history_table tbody");
    tableBody.innerHTML = "";
    loaderElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="100px" height="100px" viewBox="0 0 100 100">
    <path d="M 50,50 L 33,60.5 a 20 20 -210 1 1 34,0 z" fill="#636a75">
    <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="1.2s" repeatCount="indefinite"/>
    </path>
    <circle cx="50" cy="50" r="16" fill="#fff"></circle>
    </svg>`;
    if (bidhistoryModalModalNew.style.visibility === "visible") {
      historyTable.appendChild(loaderElement);
    }

    await window.auctionApi
      .getBids(auctionId)
      .then((response) => response.text())
      .then((result) => {
        const Bids = JSON.parse(result);
        loaderElement.remove();
        var rowData = Bids.data;
        if (rowData.length > 0) {
          // Loop through the data and create the table rows
          for (var i = 0; i < rowData.length; i++) {
            // Create a new row element
            var row = document.createElement("tr");

            // Create the cells for the row
            var bidderCell = document.createElement("td");
            bidderCell.textContent = maskPII(rowData[i].attributes.platform_customer_name);

            var amountCell = document.createElement("td");
            amountCell.textContent = `$ ${rowData[i].attributes.amount}`;

            var submittedCell = document.createElement("td");
            var timeSubmitted = getTimeAgo(
              new Date(rowData[i].attributes.placed_at)
            );
            submittedCell.textContent = timeSubmitted;

            // Append the cells to the row
            row.appendChild(bidderCell);
            row.appendChild(amountCell);
            row.appendChild(submittedCell);

            // Append the row to the table body
            tableBody.appendChild(row);
          }
        } else {
          document.querySelector(".history_table table").remove();
          document.querySelector(
            ".history_table"
          ).innerHTML = `There are no bids for this product`;
        }
      });
}

function maskPII(str) {
  const indexOfAt = str.length - 1;
  if (indexOfAt <= 1) {
    return str;
  }

  return str[0] + '*'.repeat(indexOfAt - 1) + str.substring(indexOfAt);
}

function getTimeAgo(timestamp) {
  const currentTime = new Date();
  const timeDiff = Math.floor((currentTime - timestamp) / 1000); // Time difference in seconds

  if (timeDiff < 60) {
    return `${timeDiff} seconds ago`;
  } else if (timeDiff < 3600) {
    const minutes = Math.floor(timeDiff / 60);
    return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
  } else if (timeDiff < 86400) {
    const hours = Math.floor(timeDiff / 3600);
    return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  } else {
    const days = Math.floor(timeDiff / 86400);
    return `${days} day${days > 1 ? 's' : ''} ago`;
  }
}